// Netatlasset: små kort om det rigtige elnet. Hver bane låser sit kort op, når runden er slut.
// Kort, der ikke er faktatjekket af Energinet endnu, bærer et tydeligt UTJEKKET-mærke.

import { ATLAS_FACTS, atlasId } from '../../content/atlas-facts';
import { LEVELS } from '../../content/levels';
import { h } from '../dom';
import { ICON } from '../icons';
import { SHOW_UNCHECKED } from './screens';

export function atlasTotal(): number {
  return Object.values(ATLAS_FACTS).reduce((n, l) => n + l.length, 0);
}

export function atlasScreen(unlocked: Set<string>, back: () => void): HTMLElement {
  const total = atlasTotal();
  const have = Object.entries(ATLAS_FACTS).reduce((n, [lv, list]) => n + list.filter((f) => unlocked.has(atlasId(lv, f))).length, 0);
  const cards: HTMLElement[] = [];
  for (const [lv, list] of Object.entries(ATLAS_FACTS)) {
    const level = LEVELS.find((l) => l.id === lv);
    for (const f of list) {
      const open = unlocked.has(atlasId(lv, f));
      cards.push(
        open
          ? h(
              'article',
              { class: 'atlas-card open' },
              h('header', {}, h('b', {}, f.title), f.checked || !SHOW_UNCHECKED ? null : h('span', { class: 'badge unchecked', title: 'Ikke faktatjekket af Energinet endnu' }, 'UTJEKKET')),
              h('p', {}, f.text),
              h('small', {}, `Kilde: ${f.source}`),
            )
          : h(
              'article',
              { class: 'atlas-card locked', 'aria-label': `Låst kort. Lås op på bane ${level?.number ?? ''}.` },
              h('span', { class: 'lock', html: ICON.lock }),
              h('b', {}, '???'),
              h('small', {}, `Lås op på bane ${level?.number ?? ''}`),
            ),
      );
    }
  }
  return h(
    'div',
    { class: 'card atlas' },
    h('p', { class: 'eyebrow' }, `${have} af ${total} kort`),
    h('h1', { class: 'title small' }, 'NETATLAS'),
    h('p', { class: 'lead' }, 'Små kort om det rigtige elnet. Spil en bane til ende, så låser du dens kort op.'),
    h('div', { class: 'atlas-grid' }, ...cards),
    SHOW_UNCHECKED ? h('p', { class: 'help' }, 'UTJEKKET betyder, at Energinet ikke har tjekket tal og kilde endnu.') : null,
    h('div', { class: 'actions' }, h('button', { type: 'button', class: 'btn primary', autofocus: true, onclick: () => back() }, 'Tilbage')),
  );
}
